'use strict';

/**
 * @generated SignedSource<<6bab3d0dee6f41af2c8546553d5b4989>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offerIds"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "offerIds",
                    "variableName": "offerIds"
                }
            ],
            "concreteType": "ProductOfferDetailsResponse",
            "kind": "LinkedField",
            "name": "productOfferDetails",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "BaseOfferDetail",
                    "kind": "LinkedField",
                    "name": "offerDetails",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGrandfathered",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CurrentPlanQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CurrentPlanQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "8f0789b08d36a06a0a9bb34f58248fd7",
            "id": null,
            "metadata": {},
            "name": "CurrentPlanQuery",
            "operationKind": "query",
            "text": "query CurrentPlanQuery(\n  $offerIds: [String!]\n) {\n  productOfferDetails(offerIds: $offerIds) {\n    offerDetails {\n      isGrandfathered\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "7aa0a436cd562ccd845aa047079cad46";

module.exports = node;
